// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const alphaottColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: alphaottColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: alphaottColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: alphaottColors.primaryGray,
    secondary: alphaottColors.secondaryGray,
    disabled: alphaottColors.grayText,
    link: alphaottColors.secondaryGray,
    hint: alphaottColors.white,
    highlight: alphaottColors.secondary,
    gray: alphaottColors.primaryGray,
    seeAll: alphaottColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: alphaottColors.primaryGray,
    gray: alphaottColors.secondaryGray,
  },
  filter: {
    primary: alphaottColors.primaryGray,
    secondary: alphaottColors.secondaryGray,
    disabled: alphaottColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: alphaottColors.dark,
    color: alphaottColors.white,
    border: alphaottColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: alphaottColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: alphaottColors.dark,
        selected: alphaottColors.dark,
        progress: rgba(alphaottColors.primary, 0.3),
        past: rgba(alphaottColors.primary, 0.3),
        pastSelected: alphaottColors.dark,
        pastHover: alphaottColors.dark,
        empty: '#555555',
        emptyProgress: rgba(alphaottColors.primary, 0.2),
      },
      text: {
        empty: alphaottColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: alphaottColors.white,
    subTitle: alphaottColors.secondaryGray,
    bg: alphaottColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
